import { Flex, Typography } from '@banhala/ui-kit';
import React from 'react';

export const BottomTabBarItem: React.FC<{
  name: string;
  focused: boolean;
  icon: React.ReactNode | null;
  onPress: () => void;
}> = props => {
  return (
    <Flex.Center
      flex={1}
      onPress={props.onPress}
      padding={{ top: 4, bottom: 2, horizontal: 4 }}
      gap={4}
    >
      {props.icon}
      <Typography
        type={'body5'}
        color={props.focused ? 'content_primary' : 'content_secondary'}
      >
        {props.name}
      </Typography>
    </Flex.Center>
  );
};
